class StickyNav {
  constructor() {
    this.$nav = null;
    this.$mobileMenu = null;
    this.navHeight = 0;
    this.headerHeight = 0;
    this.lastScrollY = 0;
    this.mobileMenuOpen = false;
    document.addEventListener('DOMContentLoaded', e => this.init());
  }

  init() {
    this.$nav = document.querySelector('[data-sticky-nav-mobile]');
    this.$mobileMenu = document.querySelector('#menu-mobile');
    if(!this.$nav || !this.$mobileMenu) return;

    let header = document.querySelector('#shopify-section-header'),
        quickLinks = document.querySelector('#shopify-section-quicklinks');

    this.headerHeight = header?.offsetHeight + quickLinks?.offsetHeight;
    this.navHeight = this.$nav.offsetHeight;
    this.lastScrollY = window.scrollY;

    document.addEventListener('scroll', e => {
      if(window.innerWidth <= 900) {
        this.mobileMenuOpen = document.querySelector('#menu-mobile.open');

        // are we scrolling up and past the header?
        if(this.lastScrollY > window.scrollY && window.scrollY > this.headerHeight) {
          this.showStickyNav = true;
          this.$mobileMenu.style.paddingTop = `${this.navHeight - 1}px`
        } else if(!this.mobileMenuOpen && this.lastScrollY < window.scrollY || window.scrollY < this.headerHeight) {
          this.showStickyNav = false;
          this.$mobileMenu.style.paddingTop = '';
        }
      } else {
        this.showStickyNav = false;
      }

      this.$nav.setAttribute('aria-hidden', !this.showStickyNav)
      this.lastScrollY = window.scrollY;
    }, { passive: true });
  }
}

new StickyNav();

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', e => {
    if (e.target.querySelector(`#${e.detail.sectionId}`)) {
      let stickyNav = new StickyNav();
      stickyNav.init(); // DOM content already loaded in design mode
    }
  });
}

